<app-image-loader (click)="goToHome($event)" #imgLoaderLogo class="fade-in"
        [style]="stylesObj"
        [images]="resellerLogo"
        [defaultImage]="'assets/images/DSLogo.png'">
</app-image-loader>

<!--<img *ngIf="logoUrl" [ngClass]="{mainLogoBg: applyDefaultClass}" class="fade-in " onerror="this.src = 'assets/images/DSLogo.png'" [src]="logoUrl"/>-->
<!--[ngClass]="{mainLogoBg: someClass}"-->
